<script >
    import RoundCheckIco from '../../components/icons/round-check.svelte'
    import EyeIco from '../../components/icons/eye.svelte'
    import Modal from '../../components/modal/modal.svelte'
    import { createEventDispatcher } from 'svelte'
    import RoundInfoIco from '../../components/icons/round-info.svelte'
    export let document
    let showModal = false

    const dispatch = createEventDispatcher()
</script>

<style lang="scss">
    .document-item {
        padding: 15px 0;
        border-bottom: 1px solid #373D3A;
        display: flex;
        position: relative;
        div {
            flex: 1 1 auto;
            &.img {
                flex: 0 1 95px;
                padding-right: 15px;
                .in {
                    position: relative;
                    display: inline-block;
                    img {
                        display:block;
                        max-width: 75px;
                        max-height: 50px;
                    }
                    .overlay {
                        background: rgba(223,73,55,0.52);
                        position:absolute;
                        top: 0;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        cursor: pointer;
                        .ico {
                            position: absolute;
                            left: calc(50% - 10px);
                            top: calc(50% - 7px);
                        }
                    }
                }
            }
            &.name {
                line-height: 22px;
                font-family: Roboto;
                font-weight: 700;
                font-size: 15px;
                color: #FFFFFF;
                letter-spacing: 0.04px;
                span, .text {
                    display: inline-block;
                    position: relative;
                    padding-left: 35px;
                    .ico {
                        position: absolute;
                        left: 0;
                        top: 10px;
                        .error {
                            display: none;
                            position: absolute;
                            bottom: 100%;
                            left: -5px;
                            width: 220px;
                            background-color: #fff;
                            padding: 10px;
                            border-radius: 5px;
                            font-family: Roboto;
                            font-weight: 300;
                            font-size: 15px;
                            color: #242927;
                            letter-spacing: 0.2px;
                            line-height: 29px;
                        }
                        &:hover {
                            .error {
                                display: block;
                            }
                        }
                    }
                    .type {
                        font-family: Roboto;
                        font-weight: 400;
                    }
                }
            }
            &.actions {
                line-height: 50px;
                text-align: right;
                span {
                    font-family: Roboto;
                    font-weight: 700;
                    font-size: 13px;
                    color: #DF4937;
                    letter-spacing: 0.2px;
                    display: inline-block;
                    margin-left: 15px;
                    cursor: pointer;
                    text-decoration: underline;
                    &:hover {
                        text-decoration: none;
                    }
                }
            }
        }
        .uploading {
            background: rgba(36,42,39, 0.9);
            position:absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            text-align: center;
            .text {
                line-height: 84px;
                position: relative;
                padding-left: 30px;
                display: inline-block;
                .ico {
                    position: absolute;
                    left: 0;
                    top: 5px
                }
            }
        }
        .document-image {
            max-width: 90%;
            max-height: 90%;
        }
        &:last-child {
            border: none;
        }
    }
</style>

{#if document}
<div class="document-item">
    <div class="img">
        <div class="in">
            <img src={window.URL.createObjectURL(document.file)} alt="document preview">
            <div class="overlay" on:click={() => showModal = document.file}>
                <div class="ico">
                    <EyeIco />
                </div>
            </div>
        </div>
    </div>
    <div class="name">
        <div class="text">
            <div class="ico">
                {#if document.isValid}
                    <RoundCheckIco />
                {/if}
                {#if !document.isValid}
                    <div class="error">{document.error}</div>
                    <RoundInfoIco />
                {/if}
            </div>
            <div class="filename">
                {document.file.name}<br />
            </div>
            {#if document.type}
            <div class="type">
                {#if Array.isArray(document.type)}
                    {#if document.type.join(', ').replace(/_/g, ' ') == "id 2012 back"}
                        "id 2012 back or newer"
                    {:else}
                        {document.type.join(', ').replace(/_/g, ' ')}
                    {/if}
                {:else}
                    {document.type.replace(/_/g, ' ')}
                {/if}
            </div>
            {/if}
        </div>
    </div>
    <div class="actions">
        <span on:click={() => dispatch('delete', document)}>Delete file</span>
    </div>
    {#if document.isUploading}
    <div class="uploading">
        <div class="text">
            <div class="ico">
                <RoundCheckIco />
            </div>
            Uploading document...
        </div>
    </div>
    {/if}
    {#if showModal}
        <Modal on:close="{() => showModal = false}">
            <img class="document-image" src={window.URL.createObjectURL(document.file)} alt="document preview">
        </Modal>
    {/if}
</div>
{/if}
